import StopRecordingIcon from "../../assets/icons/stop-recording-icon"
import Shell from "../shell"
import RecordingProgress from "./recording-progress"

interface RecordingScreenProps {
    timeElapsed: number
    isRecordingSuccess: boolean
    handleStopRecording: () => void
}

const RecordingScreen = ({
    timeElapsed,
    isRecordingSuccess,
    handleStopRecording,
}: RecordingScreenProps) => {
    return (
        <Shell
            footerElement={
                <>
                    {!isRecordingSuccess && (
                        <div className="mt-auto w-[100%]">
                            {/* Recording Validation Message */}
                            <div className="mt-auto text-center text-xs text-onSurface-primary mb-3">
                                Recording should be of minimum 30 seconds
                            </div>
                            <div className="w-full px-4">
                                <button
                                    onClick={handleStopRecording}
                                    className="w-[100%] p-4 border-solid border-[#CB2F67] border-[1px] rounded-lg flex justify-center items-center bg-white  mb-6"
                                >
                                    <StopRecordingIcon />
                                    <p className="ml-2 font-semibold text-base text-[#CB2F67]">
                                        Stop recording
                                    </p>
                                </button>
                            </div>
                        </div>
                    )}
                    {/* Empty span for positioning */}
                    {isRecordingSuccess && (
                        <span className="w-[100%] p-10 mt-auto bg-transparent" />
                    )}
                </>
            }
        >
            <div className="min-h-full min-w-full my-auto flex items-center justify-center">
                <RecordingProgress
                    timeElapsed={timeElapsed}
                    isRecordingSuccess={isRecordingSuccess}
                />
            </div>
        </Shell>
    )
}
export default RecordingScreen
